var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSoftError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M42.525 92.556 4.087 54.118c-3.412-3.42-3.412-8.76 0-12.17l38.438-38.44c3.42-3.42 8.76-3.42 12.17 0l38.44 38.44c3.42 3.41 3.42 8.75 0 12.17l-38.44 38.438c-3.41 3.412-8.966 3.412-12.17 0z",
    style: {
      fill: "#ffc234",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.385 66.714c0-.643.208-1.277.425-1.919.208-.642.642-1.068 1.068-1.493a4.484 4.484 0 0 1 1.71-1.068c.634-.217 1.276-.434 2.135-.434.851 0 1.493.217 2.136.434a4.515 4.515 0 0 1 1.701 1.068c.434.425.86.85 1.068 1.493.217.642.434 1.276.434 1.919 0 .642-.217 1.284-.434 1.927-.208.633-.634 1.067-1.068 1.493A4.73 4.73 0 0 1 50.86 71.2c-.643.209-1.285.426-2.136.426-.859 0-1.501-.217-2.135-.426-.643-.216-1.068-.642-1.71-1.067-.426-.426-.86-.86-1.068-1.493-.217-.643-.425-1.068-.425-1.927Zm8.967-9.819H44.66l-1.068-32.248h9.827z",
    style: {
      fill: "#5d4037",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSoftError);
export default __webpack_public_path__ + "static/media/status-soft-error.97e9a35e74efdb66b7d2f9cd5adc2d70.svg";
export { ForwardRef as ReactComponent };